import { render, staticRenderFns } from "./VatExceptionIndex.vue?vue&type=template&id=1c8caf2c&scoped=true&"
import script from "./VatExceptionIndex.vue?vue&type=script&lang=js&"
export * from "./VatExceptionIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8caf2c",
  null
  
)

export default component.exports